import { Container } from "react-bootstrap";
import React from "react";

export const Presentations = () => {
    const presentations = [
        {
            title: "Training Models to Detect Successive Robot Errors from Human Reactions",
            event: "Northeast Robotics Colloquium (NERC ‘25)",
            date: "October 2025"
        },
        {
            title: "Recognizing Human Response to Witnessing Robot Error",
            event: "Cornell University Spring 2025 Undergraduate Research Poster Session",
            date: "April 2025"
        },
        {
            title: "“I’m Done”: Describing Human Reactions to Successive Robot Failure",
            event: "ACM/IEEE International Conference on Human-Robot Interaction (HRI ‘25)",
            date: "March 2025"
        }
    ];

    return (
        <section className="skills-section" id="presentations" style={{ paddingTop: '50px', paddingBottom: '100px' }}>
            <Container>
                <h2 className="section-title text-center">Presentations</h2>
                <div className="mt-5 d-flex flex-column gap-4">
                    {presentations.map((pres, index) => (
                        <div className="project-card p-4" key={index} style={{ height: 'auto' }}>
                            <div className="project-content p-0">
                                <h3 className="mb-2">{pres.title}</h3>
                                <p className="mb-2" style={{ color: '#cfdffc' }}>{pres.event}</p>
                                <p className="mb-0" style={{ fontSize: '14px', color: '#90fff0' }}>{pres.date}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
}
